export default "__VITE_PUBLIC_ASSET__4eb958df__"